<div class="p-3 box h-100 overflow-auto crm-scroll">
  <mat-card class="shadow-none bg-transparent">
    <mat-card-content class="bg-white rounded-2 p-4">
      <div class="d-flex align-items-center gap-2 py-2">
        <app-search
          class="search transition"
          customClass="!text-gray-900 placeholder:!text-gray-400"
          (onValueChange)="onSearchChange($event)"
        ></app-search>
        <div class="flex-fill"></div>
        @if (canManageTeam) {
          <app-button (onChangeClick)="onInviteEmployees()">
            <span class="flex items-center gap-1">
              <app-icon class="!h-5 !w-5 !text-[20px] !leading-5">person_add</app-icon>
              {{ 'invite' | translate }}
            </span>
          </app-button>
        }
        @if (selectionTable.selected.length && canManageTeam) {
          <div>
            <app-button #t="matMenuTrigger" [matMenuTriggerFor]="menu">
              <div class="d-flex flex-nowrap align-items-center">
                <span class="selected_dropdown"
                  >({{ selectionTable.selected.length }}) {{ 'selected' | translate }}</span
                >
                <app-icon class="align-middle selected_dropdown">
                  {{ t.menuOpen ? 'expand_less' : 'expand_more' }}
                </app-icon>
              </div>
            </app-button>
            <mat-menu #menu="matMenu" yPosition="below" xPosition="before" class="p-0">
              @for (item of bulkActionList; track item; let i = $index) {
                <button mat-menu-item (click)="bulkActionPopup(item)">
                  {{ item.label | translate }}
                </button>
              }
            </mat-menu>
          </div>
        }
      </div>

      @if (isLoader) {
        <div class="d-flex justify-content-center">
          <app-loader size="small"></app-loader>
        </div>
      } @else {
        @if (dataSource$ | async; as dataSource) {
          <app-table
            (menuSelected)="onActionChange($event)"
            (onPaginationChange)="onPaginationChange($event)"
            (onSortChange)="onSortChange($event)"
            (onTableRowClick)="onRowClick($event.row)"
            [dataSource]="dataSource"
            [showUpPagination]="true"
            [visibleColumnKeys]="visibleColumns"
            [selection]="selectionTable"
            class="w-100"
            classImage="image-table"
          ></app-table>
        }
      }
    </mat-card-content>
  </mat-card>
</div>

<ng-template #suspendReassignTemplate>
  <div class="mb-3 min-w-[280px]">
    <app-select
      [options]="suspendManagerOptions"
      [(ngModel)]="suspendNewManagerId"
      label="{{ 'dialogs.tab_managers_suspend_reassign' | translate }}"
      placeholder="{{ 'dialogs.tab_managers_suspend_reassign_placeholder' | translate }}"
      optionLabel="name"
      [isAvatar]="true"
      optionValue="id"
      [filter]="true"
      [showClear]="true"
    />
  </div>
</ng-template>
